import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { mergeMap, filter, map } from 'rxjs/operators';
import { Pages } from '../types/pages.enum';

export interface LastChildRouteData {
  title: string;
  activePage: Pages;
}

@Injectable({
  providedIn: 'root',
})
export class LastChildRouteService {
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  routeData$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map(() => this.activatedRoute),
    map((route) => {
      while (route.firstChild) {
        route = route.firstChild;
      }
      return route;
    }),
    filter((route) => route.outlet === 'primary'),
    mergeMap((route) => route.data as Observable<LastChildRouteData>),
  );
}
